import React, { useState, useEffect } from 'react';
import './BlockUser.css';

function BlockUser({ userId, userName, onBlock, onUnblock }) {
  const [isBlocked, setIsBlocked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [reason, setReason] = useState('');
  const [notes, setNotes] = useState('');

  useEffect(() => {
    checkBlockStatus();
  }, [userId]);

  const checkBlockStatus = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`/api/blocks/check/${userId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setIsBlocked(data.blockedByMe);
      }
    } catch (error) {
      console.error('Error checking block status:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleBlock = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`/api/blocks/${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ reason, notes }),
      });

      if (response.ok) {
        setIsBlocked(true);
        setShowModal(false);
        setReason('');
        setNotes('');
        if (onBlock) onBlock();
      } else {
        const data = await response.json();
        alert(data.error || 'Failed to block user');
      }
    } catch (error) {
      console.error('Error blocking user:', error);
      alert('Failed to block user');
    }
  };

  const handleUnblock = async () => {
    if (!window.confirm(`Are you sure you want to unblock ${userName}?`)) {
      return;
    }

    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`/api/blocks/${userId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        setIsBlocked(false);
        if (onUnblock) onUnblock();
      } else {
        alert('Failed to unblock user');
      }
    } catch (error) {
      console.error('Error unblocking user:', error);
      alert('Failed to unblock user');
    }
  };

  return (
    <>
      {loading ? (
        <button className="block-btn" disabled style={{ opacity: 0.5 }}>
          Block User
        </button>
      ) : isBlocked ? (
        <button onClick={handleUnblock} className="unblock-btn">
          Unblock User
        </button>
      ) : (
        <button onClick={() => setShowModal(true)} className="block-btn">
          Block User
        </button>
      )}

      {showModal && (
        <div className="block-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="block-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Block {userName}?</h2>
              <button onClick={() => setShowModal(false)} className="close-btn">
                ×
              </button>
            </div>

            <div className="modal-content">
              <p className="warning-text">
                Blocking {userName} will:
              </p>
              <ul className="block-effects">
                <li>Remove any existing connection</li>
                <li>Cancel pending connection requests</li>
                <li>Hide your profile from them</li>
                <li>Hide their profile from you</li>
                <li>Prevent future contact</li>
              </ul>

              <div className="form-group">
                <label htmlFor="reason">Reason (Optional)</label>
                <select
                  id="reason"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  className="form-select"
                >
                  <option value="">Select a reason...</option>
                  <option value="harassment">Harassment</option>
                  <option value="spam">Spam</option>
                  <option value="inappropriate">Inappropriate behavior</option>
                  <option value="fake_profile">Fake profile</option>
                  <option value="uncomfortable">Makes me uncomfortable</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="notes">Additional Notes (Optional)</label>
                <textarea
                  id="notes"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  placeholder="Any additional details..."
                  rows="3"
                  className="form-textarea"
                />
              </div>

              <p className="info-text">
                You can unblock {userName} at any time from your Blocked Users list.
              </p>
            </div>

            <div className="modal-actions">
              <button onClick={() => setShowModal(false)} className="cancel-btn">
                Cancel
              </button>
              <button onClick={handleBlock} className="confirm-block-btn">
                Block User
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default BlockUser;
